// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Upload-Button{display:inline}.Upload-Button label{margin:0}", "",{"version":3,"sources":["webpack://./global/Styles/Upload.scss"],"names":[],"mappings":"AAAA,eACE,cAAA,CAEA,qBACE,QAAA","sourcesContent":[".Upload-Button {\n  display: inline;\n\n  label {\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
